import { createRoute, redirect } from '@tanstack/react-router';
import { queryClient } from '@/App.tsx';
import WaitlistLayout from '@/features/public/waitlist/components/WaitlistLayout.tsx';
import WaitlistPage from '@/features/public/waitlist/pages/WaitlistPage.tsx';
import BookingPendingSkeleton from '@/features/public/booking/components/BookingPendingSkeleton.tsx';
import BookingErrorPage from '@/features/public/booking/pages/BookingErrorPage.tsx';
import { rootRoute } from '@/routing/rootRoute.ts';
import { getWaitlistBasicInfoQueryOptions } from '@/features/public/waitlist/hooks/useGetWaitlistBasicInfo.ts';
import { FunnelEventStage } from '@/features/public/booking/tracking/FunnelEventStage.ts';
import { trackFunnelStage } from '@/features/public/booking/tracking/funnelTracker.ts';

export const waitlistPublicRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'waitlist/$orgSlug/$tourSlug',
  loader: async ({ params }) => {
    const { orgSlug, tourSlug } = params;
    const tourBasicInfo = await queryClient.ensureQueryData(
      getWaitlistBasicInfoQueryOptions(orgSlug, tourSlug),
    );

    // Poza oknem listy backend odbiłby zapis (`error.waitlist.not_available`).
    // Odsyłamy na stronę rezerwacji — tam `resolveBookingView` pokaże właściwy
    // powód: wyjazd odwołany, zapisy nieogłoszone albo wyjazd już po terminie.
    if (!tourBasicInfo.waitlistAvailable) {
      throw redirect({
        to: '/booking/$orgSlug/$tourSlug',
        params: { orgSlug, tourSlug },
      });
    }

    trackFunnelStage(orgSlug, tourSlug, FunnelEventStage.WAITLIST_VIEWED);

    return { tourBasicInfo };
  },
  component: WaitlistLayout,
  pendingComponent: BookingPendingSkeleton,
  errorComponent: BookingErrorPage,
});

export const waitlistFormRoute = createRoute({
  getParentRoute: () => waitlistPublicRoute,
  path: '/',
  component: WaitlistPage,
});
